import { hexToRgb } from "../../Utils/utils";

export const navTabOptions = [
  {
    label: "Home",
    value: "/",
  },
  {
    label: "Customers",
    value: "/customers",
  },
  {
    label: "Designs",
    value: "/designs",
  },
  {
    label: "Team",
    value: "/team",
  },
  {
    label: "About us",
    value: "/about",
  },
  {
    label: "Contact",
    value: "/contact",
  },
];

export const selectStyles = (hex, white) => {
  const { r, g, b } = hex ? hexToRgb(hex) : { r: 255, g: 255, b: 255 };
  return {
    container: (provided) => ({
      ...provided,
      width: "100%",
    }),
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused
        ? `rgb(${r}, ${g}, ${b})`
        : provided.borderColor,
      "&:hover": {
        borderColor: state.isFocused
          ? `rgb(${r}, ${g}, ${b})`
          : provided.borderColor,
      },
      boxShadow: state.isFocused
        ? `0 0 0 1px rgb(${r}, ${g}, ${b})`
        : provided.boxShadow,
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? hex || "blue" : "white",
      color: state.isSelected ? (white ? "white" : "black") : "black",
      "&:hover": {
        backgroundColor: state.isSelected
          ? hex || "blue"
          : `rgba(${r},${g},${b}, 0.6)`,
        color: white ? "white" : "black",
      },
    }),
  };
};



// WEBPACK FOOTER //
// ./src/screens/OnboardingSite/constants.js